import { render, staticRenderFns } from "./CarrierFee.vue?vue&type=template&id=7298a336"
import script from "./CarrierFee.vue?vue&type=script&lang=js"
export * from "./CarrierFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports